import React, { useMemo } from 'react';
import { Box, Card, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { Seat } from './Seat';

export const BusLayout = ({ bus, getSeatStatus, handleSelectSeat, onTimerEnd }) => {
    const seatColumns = useMemo(() => {
        const columns = [[], [], [], []];
        for (let i = 0; i < bus.seats.length; i += 5) {
            const row = bus.seats.slice(i, i + 5);
            if (row[0]) columns[0].push(row[0]);
            if (row[1]) columns[1].push(row[1]);
            if (row[3]) columns[2].push(row[3]);
            if (row[4]) columns[3].push(row[4]);
        }
        return columns;
    }, [bus.seats]);

    const seatContainerVariants = {
        hidden: { opacity: 1 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.015 },
        },
    };

    return (
        <Card sx={{ border: '1.5px solid grey', mb: 1, p: 1 }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minWidth: '50px',
                    }}
                >
                    <Box sx={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)' }}>
                        <Typography
                            variant="h6"
                            sx={{
                                px: 1,
                                py: 1,
                                border: '2px solid #000',
                                borderRadius: '6px',
                                backgroundColor: '#f0f0f0',
                                fontWeight: 'bold',
                                letterSpacing: 2,
                                color: '#000',
                                textAlign: 'center',
                                boxShadow: 'inset 0 0 4px rgba(0,0,0,0.3)',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            {bus.plate}
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ overflowX: 'auto', py: 2, pr: 2, pl: 1 }}>
                    <motion.div
                        initial="hidden"
                        animate="visible"
                        variants={seatContainerVariants}
                        style={{
                            display: 'inline-flex',
                            flexDirection: 'column',
                            gap: 12,
                            alignItems: 'flex-start',
                        }}
                    >
                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, mb: 1, minWidth: 'max-content' }}>
                            {seatColumns[0].map((seat) => (
                                <Seat
                                    key={seat.id}
                                    seat={seat}
                                    status={getSeatStatus(seat, bus.id)}
                                    onSelect={(seatId) => handleSelectSeat(seatId, bus.id)}
                                    onTimerEnd={(seatId) => onTimerEnd(seatId, bus.id)}
                                />
                            ))}
                        </Box>

                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, mb: 1, minWidth: 'max-content' }}>
                            {seatColumns[1].map((seat) => (
                                <Seat
                                    key={seat.id}
                                    seat={seat}
                                    status={getSeatStatus(seat, bus.id)}
                                    onSelect={(seatId) => handleSelectSeat(seatId, bus.id)}
                                    onTimerEnd={(seatId) => onTimerEnd(seatId, bus.id)}
                                />
                            ))}
                        </Box>

                        <Box sx={{ height: 25 }} />

                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, mb: 1, minWidth: 'max-content' }}>
                            {seatColumns[2].map((seat) => (
                                <Seat
                                    key={seat.id}
                                    seat={seat}
                                    status={getSeatStatus(seat, bus.id)}
                                    onSelect={(seatId) => handleSelectSeat(seatId, bus.id)}
                                    onTimerEnd={(seatId) => onTimerEnd(seatId, bus.id)}
                                />
                            ))}
                        </Box>

                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, minWidth: 'max-content' }}>
                            {seatColumns[3].map((seat) => (
                                <Seat
                                    key={seat.id}
                                    seat={seat}
                                    status={getSeatStatus(seat, bus.id)}
                                    onSelect={(seatId) => handleSelectSeat(seatId, bus.id)}
                                    onTimerEnd={(seatId) => onTimerEnd(seatId, bus.id)}
                                />
                            ))}
                        </Box>
                    </motion.div>
                </Box>
            </Box>
        </Card>
    );
};
